var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileAppStoreLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 23 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#5F787E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.593 14.551a6.218 6.218 0 012.961-5.217 6.365 6.365 0 00-5.015-2.711c-2.11-.222-4.155 1.262-5.23 1.262-1.097 0-2.752-1.24-4.535-1.204a6.679 6.679 0 00-5.62 3.428c-2.43 4.207-.617 10.39 1.71 13.792 1.165 1.665 2.526 3.525 4.307 3.46 1.743-.073 2.394-1.112 4.498-1.112 2.084 0 2.695 1.111 4.512 1.07 1.87-.031 3.048-1.673 4.172-3.355a13.774 13.774 0 001.908-3.885 6.009 6.009 0 01-3.668-5.528zM15.16 4.386A6.122 6.122 0 0016.562 0a6.23 6.23 0 00-4.03 2.085 5.826 5.826 0 00-1.437 4.224 5.15 5.15 0 004.067-1.923z"
  }))));
}
export default SvgMobileAppStoreLogo;